// src/store/compressSlice.js
import { createSlice } from "@reduxjs/toolkit";

const submerchantBranchUpdationSlice = createSlice({
  name: "taskBoard",
  initialState: {
    isTriggered: false,
    isTriggeredForNurture: false,
  },
  reducers: {
    toggleTrigger: (state) => {
      state.isTriggered = !state.isTriggered;
    },
    setTrigger: (state, action) => {
      state.isTriggered = action.payload;
    },
    toggleTriggerForNurture: (state, action) => {
      state.isTriggeredForNurture = action.payload;
    },
  },
});

export const { setTrigger, toggleTrigger, toggleTriggerForNurture } =
  submerchantBranchUpdationSlice.actions;

export default submerchantBranchUpdationSlice.reducer;
